class TrimCalculator {
    constructor(element) {
        this.element = element;
        this.length = parseFloat(element.dataset.length);
        this.linearFeetInput = element.querySelector('#linearFeet');
        this.piecesInput = element.querySelector('#quantity');
        this.trimLengthSpan = element.querySelector('#trimLength');
        this.productPrice = parseFloat(element.dataset.price);
        this.totalPrice = element.querySelector('.calc_total');
        
        this.init();
    }
    
    init() {
        this.linearFeetInput.addEventListener('input', (e) => {
            this.updatePiecesFromLinearFeet(e.target.value);
        });
        
        this.piecesInput.addEventListener('input', (e) => {
            this.updateLinearFeetFromPieces(e.target.value);
        });
        const changeEvenet = new Event('input');
        this.piecesInput.dispatchEvent(changeEvenet);
    }
    
    updatePiecesFromLinearFeet(linearFeet) {
        const feet = parseFloat(linearFeet) || 0;
        const lengthInFeet = this.length / 12;
        const pieces = Math.ceil(feet / lengthInFeet);
        this.piecesInput.value = pieces;
        this.updateTotalPrice();
    }
    
    updateLinearFeetFromPieces(pieces) {
        const count = parseInt(pieces) || 0;
        const lengthInFeet = this.length / 12;
        const linearFeet = (count * lengthInFeet).toFixed(2);
        this.linearFeetInput.value = linearFeet;
        this.updateTotalPrice()
    }

    updateTotalPrice() {
      const qty = this.getPieces();
      const linearFeet = this.getLinearFeet();
      const totalPrice = ((this.productPrice * qty ) / 100).toFixed(2);

      if (qty === 1) {
        this.totalPrice.innerHTML = `$${totalPrice} <small>for ${qty} trim (${linearFeet} lin. ft.)</small>`;
      }
      else if (qty > 1) {
        this.totalPrice.innerHTML = `$${totalPrice} <small>for ${qty} trims (${linearFeet} lin. ft.)</small>`;
      } else {
        this.totalPrice.innerHTML = `$${totalPrice}`;
      }
    }
    
    getLinearFeet() {
        return parseFloat(this.linearFeetInput.value) || 0;
    }
    
    getPieces() {
        return parseInt(this.piecesInput.value) || 0;
    }
    
    setLength(newLength) {
        this.length = newLength;
        this.trimLengthSpan.textContent = newLength;
        this.element.dataset.length = newLength;
    }
}

document.addEventListener('DOMContentLoaded', function() {
    if (document.querySelector('.trim-calculator')) {
      const calculator = new TrimCalculator(document.querySelector('.trim-calculator'));
    }
});